import $ from 'jquery';
import '../../common/js/lazyload/lazyload';

const CLASS_ITEM_MORE = '.brandhub-thumb-item.brandhub-more';
const CLASS_CARD_MORE = '.brandhub-thumb-item.brandhub-card-transition.brandhub-more';

function handleClick (elem, listElem) {
  if (!elem.hasClass('ajax-load-more')) {
    elem.addClass('disabled');
  }
  if (elem.hasClass('loadSome')) {
    const total = listElem.find(CLASS_ITEM_MORE).length;
    listElem.find(CLASS_ITEM_MORE).each((i, moreElem) => {
      if (i <= 5) {
        $(moreElem).fadeIn();
        $(moreElem).removeClass('brandhub-more');
      }
    });
    elem.removeClass('disabled');

    if (total <= 5) {
      listElem.addClass('brandhub-show-more');
      listElem.lazyLoadXT();
    }

    const totalAfter = listElem.find(CLASS_ITEM_MORE).length;
    if (totalAfter === 0) {
      $('.brandhub-thumb-more-button-container').css('display', 'none');
    }
  } else {
    listElem.find(CLASS_CARD_MORE).removeClass('view');
    listElem.addClass('brandhub-show-more');
    listElem.find(CLASS_CARD_MORE).each((i, moreElem) => {
      $(moreElem).removeClass('delay-stack').addClass(`delay-${i}`);
    });
    setTimeout(() => {
      listElem.find(CLASS_CARD_MORE).addClass('view');
      listElem.lazyLoadXT();
    }, 100);
  }
}

$(document).ready(() => {
  const moreButtons = $('*[data-js-init="brandhub-thumb-more-button"]');

  if (moreButtons.length > 0) {
    moreButtons.each((i, elem) => {
      const $elem = $(elem);
      const listElem = $elem.closest('.brandhub-thumb-list');
      $elem.on('click', () => handleClick($elem, listElem));
    });
  }
});



// WEBPACK FOOTER //
// ./custom_dependencies/brandhub-embxp-frontend/daimler-brandhub-modules/daimler-brandhub-design/daimler-brandhub-design-package/frontend/src/components/grid/brandhub-thumb.js